<template>
	<div class="my-table contactPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
     		  <img class="location" src="@/assets/picture/icon/location.png">
     		  <span>{{$t("contactPage.txt1")}}</span>
     		  <span>{{$t("contactPage.txt2")}} / {{subNavIndex === 0?$t("contactPage.txt3"):$t("contactPage.txt4")}}</span>
     		</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard p30">
			<div class="contactTitle">
				<span :class="subNavIndex==index?'activeTitle':''" v-for="(item,index) in settingOption" :key="index" @click="goItemPage(item,index)">{{item.name}}</span>
			</div>
			<div v-if="subNavIndex===0">
				<div class="banner" :style="{backgroundImage: 'url(' + picUrl + ')'}"></div>
				<div class="contentBox">
					<el-row :gutter="20">
						<el-col :span="12">
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/company_w__img@2x.png">
								<!-- <div class="bBox">上海承蓝数据科技有限公司</div> -->
							</div>
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/email_w_img@2x.png">
								<!-- <div class="bBox">support@chenglan.com</div> -->
							</div>
							<div class="contactLeft phoneContact">
								<img width="40" height="40" src="@/assets/picture/icon/tel_w_img@2x.png">
								<!-- <div class="bBox">
									<p>021-62208889</p>
									<p>021-62216667</p>
									<p>4009-200-074</p>
								</div> -->
							</div>
						</el-col>
						<el-col :span="12">
							<div class="contactRight flex">
								<img width="40" height="40" src="@/assets/picture/icon/message_w_img@2x.png">
								<div class="box">
									<el-input
									  class="messageBox"
									  resize='none'
									  type="textarea"
									  :placeholder="$t('contactPage.txt5')"
									  v-model="message">
									</el-input>
									<div class="btnBox">
										<el-button @click="handleReset" class="resetBtn">{{$t('contactPage.txt6')}}</el-button>
  										<el-button @click="handleConfirm" class="confirmBtn" type="primary">{{$t('contactPage.txt7')}}</el-button>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div v-else>
				<div class="banner" :style="{backgroundImage: 'url(' + picUrl + ')'}"></div>
				<div class="contentBox">
					<el-row :gutter="20">
						<el-col :span="20">
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/edition_w_img@2x.png">
								<div class="bBox">{{$t('contactPage.txt8')}}{{fromData.currentVersion}}</div>
							</div>
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/state_w_img@2x.png">
								<div class="flex">
									<span class="mr30 bBox">{{$t('contactPage.txt9')}}{{$t('contactPage.txt10')}}-{{fromData.effective?$t("contactPage.txt11"):$t("contactPage.txt12")}}</span>
									<div class="btnBox">
  										<el-button @click="exportMachineInfo" class="confirmBtn mr30" type="primary">{{$t('contactPage.txt13')}}</el-button>
  										<el-upload
            	        				  class="uploadFild"
            	        				  :headers="importHeaders"
            	        				  :action="uploadActionUploadLicense"
            	        				  :on-success="handleAvatarSuccess"
            	        				  :on-exceed="handleAvatarExceed"
            	        				  :file-list="fileList"
            	        				  multiple
            	        				  :limit="1">
            	        				  <el-button v-if="fromData.effective" type="text" class="resetBtn">{{$t('contactPage.txt14')}}</el-button>
            	        				  <el-button v-else type="text" class="resetBtn">{{$t('contactPage.txt15')}}</el-button>
            	        				</el-upload>  
									</div>
								</div>
							</div>
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/inspect_w_img@2x.png">
								<div class="btnBox">{{$t('contactPage.txt16')}}
									<span v-if="fromData.findingUpdate" class="blueTxt mr30">{{$t('contactPage.txt17')}}{{fromData.latestVersion}}</span>
									<!-- <span class="mr30" v-if="!fromData.findingUpdate">当前已升级到最新版本</span> -->
									<span v-if="!fromData.otaOnline" class="blueTxt mr30">{{$t('contactPage.txt18')}}{{fromData.latestVersion}}</span></div>
									<div class="btnBox">
									<!-- 	<el-upload
										  v-if="!fromData.otaOnline"
            	        				  class="uploadFild"
            	        				  :headers="importHeaders"
            	        				  :action="uploadActionOtaOnline"
            	        				  :on-success="handleAvatarUpdateOfManual"
            	        				  :on-exceed="handleAvatarExceed"
            	        				  :file-list="fileList"
            	        				  multiple
            	        				  :limit="1">
            	        				  <el-button class="confirmBtn mr30" type="primary">手动升级</el-button>
            	        				</el-upload>   -->
  										<el-button v-if="fromData.findingUpdate" @click="updateNow" class="confirmBtn" type="primary">{{$t('contactPage.txt19')}}</el-button>
  									</div>
  									<div class="progressBox" v-if="!fromData.otaOnline && isUpdating">
  										<el-progress :percentage="20" :color="customColor"></el-progress>
  										<el-button type="text" class="resetBtn">{{$t('contactPage.txt20')}}</el-button>
  									</div>
							</div>
							<div class="contactLeft">
								<img width="40" height="40" src="@/assets/picture/icon/backup_w_img@2x.png">
								<div class="btnBox">{{$t('contactPage.txt21')}}
									<div class="btnBox">
  										<el-button @click="exportBackup" class="confirmBtn mr30" type="primary">{{$t('contactPage.txt22')}}</el-button>
            	        				<el-upload
            	        				  class="uploadFild"
            	        				  :headers="importHeaders"
            	        				  :action="uploadActionBackup"
            	        				  :on-success="handleAvatarImport"
            	        				  :on-exceed="handleAvatarExceed"
            	        				  :file-list="fileList"
            	        				  multiple
            	        				  :limit="1">
            	        				  <el-button class="confirmBtn mr30" type="primary">{{$t('contactPage.txt23')}}</el-button>
            	        				</el-upload>   
									</div>
								</div>
							</div>
							<div class="contactLeft" v-if="loginName === 'develop'">
								<el-row>
									<el-col :span="14">
										<div class="flex">
											<img width="40" height="40" src="@/assets/picture/icon/edition_w_img@2x.png">
											<div class="bBox flex">
												<span style="width: 120px;">{{$t('contactPage.txt24')}}</span>
												<el-input v-model="copyrightInfo" :placeholder="$t('contactPage.txt25')"></el-input>
											</div>
										</div>
									</el-col>
									<el-col :span="8">
										<div class="bBox flex">
											<span style="width: 120px;">{{$t('contactPage.txt26')}}</span>
											<el-upload
											  class="avatar-uploader"
											  :headers="importHeaders"
											  :action="uploadActionUploadLogoImage"
											  :show-file-list="false"
											  :on-success="handleAvatarLogoSuccess"
											  :on-exceed="handleAvatarExceed"
											  :before-upload="beforeResumeUploadLogo">
											  <img v-if="imageUrl" :src="imageUrl" class="avatar">
											  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
											</el-upload>
										</div>
									</el-col>
									<el-col :span="2">
										<el-button class="confirmBtn submitLogo" @click="handleSubmitInfo" type="primary">{{$t('contactPage.txt27')}}</el-button>
									</el-col>
								</el-row>
		
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { formatDate } from "@/plugins/date.js";
	import {apiUrl, serverUrl} from '@/utils/request';
	import { downloadFile } from '@/utils/fileRequest';
	import qs from 'qs';
	export default {
		data() {
			return {
				importHeaders:{},
				isIndeterminate: true,
				time: '',
				copyrightInfo:'',//版权信息
				subNavIndex: 0,
				settingOption: [{
						path: '/contactUs',
						name: this.$t('contactPage.txt3'),
						picUrl:require('@/assets/picture/icon/contactus_w_img@2x.png')
					},
					{
						path: '/copyManagement',
						name: this.$t('contactPage.txt2'),
						picUrl:require('@/assets/picture/icon/version_w_img@2x.png')
					},
				],
				options: [], //测试数据
				fromData: {},
				picUrl:'',
				message:'',
				fileList:[],
				isUpdating:false,
				customColor: '#1B3B7C',
				imageUrl:'',
				loginName:'',
				uploadActionOtaOnline: apiUrl + '/active/updateOfManual',
				uploadActionBackup:apiUrl + '/backup/import',
				uploadActionUploadLogoImage:apiUrl + '/active/uploadLogoImage',
				uploadActionUploadLicense:apiUrl + '/active/uploadLicense',
			};
		},
		created() {
			let token = window.localStorage.getItem("token");
      		this.importHeaders = {
      		  'Authorization':token
      		}
      		this.getSystemPublicConfigs();
      		this.loginName = window.sessionStorage.getItem("loginName");
			this.picUrl = this.settingOption[0].picUrl;
		},
		methods: {
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, "yyyy-MM-dd hh:mm:ss");
			},
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
			goItemPage(item,index){
				this.subNavIndex = index;
				this.picUrl = this.settingOption[index].picUrl;
				if(this.subNavIndex == 1){
					// this.validateLicense();
					this.getLicenseInfo();
				}
			},
       		handleAvatarSuccess(res, file) {
       		  if(!res.success){
       		    return this.$message.error(res.message);
       		  }
       		  this.getLicenseInfo();
       		  this.$message({
       		    type: 'success',
       		    message: res.message
       		  });
       		},
			// 手动升级(上传升级包，只允许上传zip格式的压缩文件，需要前端检验)
       		handleAvatarUpdateOfManual(res, file) {
       		  if(!res.success){
       		    return this.$message.error(res.message);
       		  }
       		  this.getLicenseInfo();
       		  this.$message({
       		    type: 'success',
       		    message: res.message
       		  });
       		},
       		// 获得系统公开的配置信息
			async getSystemPublicConfigs() {
				const { data: res } = await this.$http.get("/active/getSystemPublicConfigs");
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.copyrightInfo = res.result.copyrightInfo;
				this.imageUrl = res.result.logoBase64Images;
			},
       		// 上传Logo
       		handleAvatarLogoSuccess(res, file) {
       		  if(!res.success){
       		    return this.$message.error(res.message);
       		  }
       		  this.imageUrl = URL.createObjectURL(file.raw);
       		  this.$message({
       		    type: 'success',
       		    message: res.message
       		  });
       		},
       		// 上传备份的zip文件,参数name为file
       		handleAvatarImport(res, file) {
       		  if(!res.success){
       		    return this.$message.error(res.message);
       		  }
       		  this.getLicenseInfo();
       		  this.$message({
       		    type: 'success',
       		    message: res.message
       		  });
       		},
			handleReset(){
				this.message = '';
			},
			// 数据加载(监理现场见证记录列表)
			async handleConfirm() {
				let data = {
					message:this.message
				}
				const { data: res } = await this.$http.post("/active/leave/message?" + qs.stringify(data));

				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message({
         		  type: 'success',
         		  message: '操作成功!'
         		});
			},
			// 获得系统的License信息
			async getLicenseInfo() {
				const { data: res } = await this.$http.post("/active/getLicenseInfo" );

				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.fromData = res.result;
			},
			// 在线升级
			async updateNow() {
				const { data: res } = await this.$http.post("/active/updateNow" );
				if (!res.success) {
					this.isUpdating = true;
					return this.$message.error(res.message);
				}
				this.isUpdating = false;
				this.getLicenseInfo();
				this.$message({
       		 	  type: 'success',
       		 	  message: res.message
       		 	});
			},
      		handleAvatarExceed(files, fileList) {
      		  this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件，请删除后上传`);
      		},
      		// 限制上传
    		beforeResumeUploadLogo(file) {
    		  if(file.type == 'image/jpeg' || file.type == 'image/png'){
    		    this.atchCde = 'img';
    		  }else{
    		    this.$message.error('上传文件只能是JPG、JPEG、PNG格式!');
    		    return false;
    		  }
    		},
			// 导出激活配置文件
			async exportMachineInfo() {
				const res = await downloadFile('get', '/active/exportMachineInfo')
				this.$message.success('下载成功！')
			},
			// 导出数据
			async exportBackup() {
				const res = await downloadFile('get', '/backup/export')
				this.$message.success('导出成功！')
			},
			// 保存版本信息
			async handleSubmitInfo() {
				let data = {
					copyrightInfo:this.copyrightInfo
				}
				const { data: res } = await this.$http.post("/active/saveCopyrightInfo?" + qs.stringify(data));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message({
       		 	  type: 'success',
       		 	  message: res.message
       		 	});
			},
		},
	};
</script>

<style lang="less" scoped>
	.contactPage {
		/deep/ .checkbox, .form-control, /deep/ .radio, /deep/ input[type=file], /deep/ output{
			display: none !important;
		}
		.contactTitle{
			font-size: 30px;
			font-weight: 500;
			color: #AEB0B9;
			margin-bottom: 40px;
		}
		.contactTitle span{
			margin-right: 30px;
			cursor: pointer;
		}
		.activeTitle{
			font-size: 30px;
			font-weight: 500;
			color: #222222;
		}
		.flex{
			display: flex;
		}
		.progressBox{
			.el-progress{
				display: block;
			}
			.resetBtn{
				color: #fff !important;
				background: #1B3B7C !important;
				margin-left: 30px;
				height: 24px;
				padding-top: 0;
				display: inline-block;
			}
		}
		.blueTxt{
			color: #1B3B7C;
		}
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}
		.banner{
			width: 100%;
			height: 25rem;
			background-position: left center;
			background-repeat: no-repeat;
			background-size: cover;
			margin-bottom: 50px;
		}
		.contentBox{
			/*padding-top: 25px;*/
		}
		.mr30{
			margin-right: 30px;
		}
		.phoneContact{
			align-items: flex-start !important;
		}
		.contactLeft{
			padding-left: 220px;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin-bottom: 30px;
			img{
				margin-right: 20px;
			}
			.bBox{
				color: #333333;
				font-size: 14px;
				line-height: 30px;
			}
			.btnBox{
				display: flex;
    			align-items: center;
				/deep/ .el-button{
					margin-right: 30px;
				}
				.confirmBtn{
					width: 116px;
					height: 36px;
					background: #1B3B7C;
					border-radius: 5px;
					text-align: center;
					line-height: 0;
					color: #fff;
					border-radius: 100px;
				}
				.resetBtn{
					width: 116px;
					height: 36px;
					background:#FFFFFF;
					color: #1B3B7C;
					border: 1px solid #1B3B7C;
					text-align: center;
					line-height: 0;
					border-radius: 100px;
				}
			}
		}
		.submitLogo,.submitLogo:hover{
			margin-top: 25px;
			height: 26px !important;
			line-height: 1px !important;
			width: 120px;
		}
		.avatar-uploader{
  		  border: 1px dashed #d9d9d9 !important;
  		  border-radius: 6px;
  		  cursor: pointer;
  		  position: relative;
  		  overflow: hidden;
  		}
  		.avatar-uploader .el-upload:hover {
  		  border-color: #409EFF;
  		}
  		.avatar-uploader-icon {
  		  font-size: 28px;
  		  color: #8c939d;
  		  width: 30px;
  		  height: 30px;
  		  line-height: 30px;
  		  text-align: center;
  		}
  		.avatar {
  		  width: 30px;
  		  height: 30px;
  		  display: block;
  		}
		.contactRight{
			display: flex;
			justify-content: flex-start;
			margin-bottom: 30px;
			img{
				margin-right: 20px;
			}
			.messageBox{
				/deep/ textarea{
					width: 430px;
					height: 250px;
					background: #F4F4F4;
					border: none;
					border-radius: 6px;
				}
			}
			.btnBox{
				display: flex;
				margin-top: 30px;
    			align-items: center;
				/deep/ .el-button{
					margin-right: 0;
				}
				.confirmBtn{
					width: 88px;
					height: 36px;
					background: #1B3B7C;
					border-radius: 5px;
					text-align: center;
					line-height: 0;
					color: #fff;
					border-radius: 100px;
				}
				.resetBtn{
					width: 88px;
					height: 36px;
					background:#F4F4F4;
					color: #AEB0B9;
					text-align: center;
					line-height: 0;
					border: none;
					border-radius: 100px;
				}
			}
		}

	}
	.handleBtn{
		padding: 0;
	}
</style>
